import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";

const NAV_ITEMS = [
  { to: "/why", label: "Why" },
  { to: "/product", label: "Product" },
  { to: "/market", label: "Market" },
  { to: "/approach", label: "Approach" },
  { to: "/about", label: "About" },
];

export default function Navbar({ onAuthClick }) {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  const solid = scrolled || location.pathname !== "/";

  return (
    <nav className={`nav ${solid ? "nav-solid" : ""}`}>
      <div className="nav-inner">
        <Link to="/" className="brand">
          <span className="brand-mark">●</span> Bellboy
        </Link>
        <button className="nav-burger" aria-label="Toggle menu" aria-expanded={open} onClick={() => setOpen((o) => !o)}>
          <span />
          <span />
          <span />
        </button>
        <div className={`nav-links ${open ? "nav-links-open" : ""}`}>
          {NAV_ITEMS.map((item) => (
            <Link key={item.to} to={item.to} className={location.pathname === item.to ? "nav-link-active" : ""}>
              {item.label}
            </Link>
          ))}
          <button className="nav-link-btn" onClick={() => onAuthClick("login")}>
            Login
          </button>
          <button className="nav-cta" onClick={() => onAuthClick("register")}>
            Get Bellboy
          </button>
        </div>
      </div>
    </nav>
  );
}
